<template>
<div class="col-lg-12">
    <div class="row">
        <div class="col-lg-4">
            <div class="form-group">
                <label>ค้นหาวันที่ส่งพัสดุ (วันเริ่มต้น - วันสุดท้าย)</label>
                <date-range-picker
                    class="w-100"
                    :opens="'center'"
                    @start-selection="logEvent('startSelection', $event)"
                    @finish-selection="logEvent('finishSelection', $event)"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :singleDatePicker="false"
                    :appendToBody="true"
                    :ranges="false"
                    :closeOnEsc="false"
                    :autoApply="true"
                    :locale-data="{ format: 'dd/mm/yyyy' }"
                    v-model="date"
                    @update="onChangeDate"
                >
                </date-range-picker>
            </div>
        </div>
        <div class="col-lg-2" v-if="role.isShippop || role.isSuperadmin">
            <div class="form-group">
                <label>ค้นหาร้านค้า</label>
                <v-select
                    :options="shops"
                    class="custom-dropdown--sm"
                    label="name"
                    placeholder="ค้นหาร้านค้า"
                    v-model="filters.selectedShop"
                    :reduce="selectedShop => selectedShop.id"
                    :class="{ 'is-invalid bd-danger': $v.filters.selectedShop.$error }"
                    taggable
                ></v-select>
                <div
                    v-if="$v.filters.selectedShop.$error"
                    class="invalid-feedback d-block"
                >
                    กรุณาเลือกร้านค้า
                </div>
            </div>
        </div>
        <div class="col-lg-2">
            <div class="form-group">
                <label>ค้นหาขนส่ง</label>
                <b-form-select v-model="filters.key" :options="options"></b-form-select>
            </div>
        </div>
        <div class="col-lg-2">
            <div class="form-group">
                <label>ค้นหาสถานะ</label>
                <b-form-select v-model="filters.status" :options="optionsStatus"></b-form-select>
            </div>
        </div>
        <div class="col-lg-2">
            <div class="form-group">
                <label>ค้นหา</label>
                <div>
                    <button class="btn btn-info" @click="onClick()">
                        <i class="fa fa-search"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end col-lg">
            <b-form-group label="Export File" class="mb-0 pb-2">
                <div 
                    class="btn-group btn-sm-res" 
                    role="group" 
                    aria-label="Basic example">
                    <b-button
                        v-if="role.isShippop"
                        variant="warning"
                        @click="exportExcelDaily()"
                        :disabled="!filters.key || !filters.status"
                    >
                        <div class="circle-loading" v-if="filters.isLoadingDailyBtn"></div>
                        <template v-else> Summary ยอดที่ไม่จัดส่ง</template>
                    </b-button>
                    <b-button 
                        variant="success"
                        @click="exportExcel()"
                    >
                        <div class="circle-loading" v-if="filters.isLoadingBtn"></div>
                        <template v-else> excel </template>
                    </b-button>
                    <b-button 
                        variant="info btn-sm-res" 
                        @click="$htmlToPaper('tablePrint')"
                    >
                    print
                    </b-button>
                </div>
            </b-form-group>
        </div>
    </div>
</div>
</template>
<script>
import columns from './js/columns'
import moment from 'moment'
import { required, numeric } from "vuelidate/lib/validators"
import { dateLimitRanges } from "@/plugins/datePicker.js"
import { getListOrderDropoffForExcelS3, getListOrderDropoffDailyExcel } from '@/axios/report.js';
import { showErrorModal } from "@/components/modalNotification.js";

const DATE_NOW = moment().format("YYYY-MM-DD")
export default {
    name: 'ToolBox',
    props:{
        services:{
            type: Array,
            default: []
        },
        filters:{
            type: Object,
            default: {
                startDate: DATE_NOW,
                endDate: DATE_NOW,
                key: false,
                selectedShop: false,
                limit: 1000
            }
        },
        shops:{
            type: Array,
            default: []
        },
        orders:{
            type: Object,
            default: {
                data: [],
                current_page: 1,
                per_page: 0,
                total_item: 0,
                limit: 20
            }
        },
        onSubmit: Function
    },
    data(){
        return {
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            filter: {},
            selected: false,
            date: {
                startDate: DATE_NOW,
                endDate: DATE_NOW
            },
            role: this.$USER_LOGIN.get()
        }
    },
    validations(){
        let results = {}
        if( !this.role.isShippop && !this.role.isSuperadmin )return results
        results.filters = {
            selectedShop: { required, numeric }
        }
        if(this.role.isShippop) {
            results.filters = {
                selectedShop: { required }
            }
        }
        return results
    },
    methods:{
        logEvent( event , date ){
            const { minDate , maxDate } =  dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
        onChangeDate( date ){
            this.filters.startDate = date.startDate
            this.filters.endDate = date.endDate
        },
        exportExcel(){
            this.filters.isLoadingBtn = true
            getListOrderDropoffForExcelS3(this.filters).then( (response) => {
                let url = response.data.url;
                if(url){
                    const link = document.createElement('a')
                    link.href = url
                    link.download = `report-dropoff-${DATE_NOW}.xlsx`
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }else{
                    showErrorModal( 'ไม่มีข้อมูล' )
                }
                this.filters.isLoadingBtn = false
            }).catch( error => {
                showErrorModal( error )
                this.filters.isLoadingBtn = false
            });
        },
        exportExcelDaily() {
            this.filters.isLoadingDailyBtn = true
            getListOrderDropoffDailyExcel(this.filters).then( (response) => {
                let url = response.data.url;
                if(url){
                    const link = document.createElement('a')
                    link.href = url
                    link.download = `report-dropoff-daily-${DATE_NOW}.xlsx`
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }else{
                    showErrorModal( 'ไม่มีข้อมูล' )
                }
                this.filters.isLoadingDailyBtn = false
            }).catch( error => {
                showErrorModal( error )
                this.filters.isLoadingDailyBtn = false
            });
        },
        async onClick(){
            this.$v.$touch()
            if( this.$v.$invalid )return false
            try{
                this.setLimitPage( 20 )
                const get = await this.onSubmit()
                this.setOrder( get.data )
            }catch( err ){
                alert( 'เกิดข้อผิดพลาด' )
            }
        },
        async onExport(){
            const limit = 100000
            if( this.orders.total_item < 1 ){
                alert( 'กรุณาค้นหารายการที่ต้องการ export' )
                return false
            }else if ( this.orders.total_item > limit ){
                alert( `สามารถ export รายการได้ไม่เกิน ${limit} ชิ้น` )
                return false
            }
            try{
                const preCurrentPage = this.orders.current_page
                this.setLimitPage( limit )
                this.setCurrentPage(1)
                const get = await this.onSubmit()
                this.setLimitPage()
                this.setCurrentPage(preCurrentPage)
                return get.data.data
            }catch( err ){
                alert( 'เกิดข้อผิดพลาด' )
            }

        },
        setLimitPage( limit = 20 ){
            this.orders.limit = limit
            return limit
        },
        setCurrentPage(page){
            this.orders.current_page = page
            return page
        },
        setOrder( results ){
            this.orders.current_page = results.current_page
            this.orders.per_page = results.per_page
            this.orders.total_item = results.total_item
            this.orders.data = results.data
        },
    },
    computed:{
        options(){
            let response = []
            if( this.services.length > 0 ){
                response = this.services.reduce( (results, service) => {
                    results.push({
                        value: service.key,
                        text: service.name
                    })
                    return results
                }, [])
            }
            return [ {value: false, text: 'ดูทั้งหมด'}, ...response ]
        },
        optionsStatus(){
            return [ 
                {value: false, text: 'ดูทั้งหมด'},
                {value: 'WAIT', text: 'รอเข้าระบบ'},
                {value: 'BOOKING', text: 'รอขนส่งเข้ารับ'},
                {value: 'SHIPPING', text: 'กำลังนำส่ง'},
                {value: 'COMPLETE', text: 'นำส่งสำเร็จ'},
            ]
        },
        fields(){
            let cols = columns.filter( col => col.key !== 'index' )
            if( this.$USER_LOGIN.get().isShippop || this.$USER_LOGIN.get().isSuperadmin )
            return cols
            else return cols.filter( col => col.key !== 'shop_name' )
        }
    },
    mounted() {
        console.log('selectedShop: ', this.filters.selectedShop)
    }
}
</script>